module.exports = __webpack_public_path__ + "img/36-user.b1084348.svg";